var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanceLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.85 21.95-.64-5.73s8.07 3.86 20.86-.85c8.09-2.98 10.64-7.66 20.86-8.51C146.14 6 167 16.22 167 16.22l-6.81 1.28 2.55 7.66s-11.05-9.79-27.67-9.79c-10.22 0-9.79 5.11-22.56 6.81-17.73 2.36-17.45-.43-17.45-.43M92.94 33.24l-1.7 6.38S84 34.09 74.21 34.09c-9.79 0-17.88.43-28.52-1.7S24.41 21.32 21 11.11l7.42 4.87 1.09-7.85S37.6 22.6 49.09 25.16c11.5 2.55 23.41-4.26 43.85 8.08ZM66.76 56.44l-1.28 6.38s3.41 8.09 11.49 11.07c0 0-7.66 8.09-8.94 17.45-1.28 9.36 3.83 29.37 11.07 25.97 7.24-3.4 6.38-13.2 6.38-13.2s-1.28-13.62 2.98-21.28c4.26-7.66 11.07-10.64 10.64-20.86 0 0 2.13-3.83-9.79-6.81l-7.87 14.26s-7.23-3.4-14.68-12.98Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.38 43.46-1.7 9.79s-14.04-.43-20.85 1.92l2.12-7.02s2.98-3.83 17.03 0c0 0-6.81-4.26-16.17-3.83l2.55-7.66c0-.01 10.21 1.26 17.02 6.8ZM94.85 26.37s9.15 2.19 14.69.91v6.57s-8.94 3.17-14.69 0v-7.48Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.94 53.77s1.68 3.31 8.5-2.44l11.5 6.6 3.41 17.03-6.81 12.14s-7.66-1.5-11.49-10.44c0 0 4.26 17.45 14.05 24.69 0 0 5.11 2.13 11.07-2.55 0 0 2.98-9.43 0-17.06-2.98-7.63-8.09-15.29-6.38-22.95 1.7-7.66.43-11.92.43-11.92l-5.96-4.26.43 6.38-5.42-3.09 4.57-4.58-1.28-6.07-9.36 6.07-5.96-6.07v9.33l2.14 1.32-3.42 1.51v6.36h-.02Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.24 1.24 64.5 15.5",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.818 45.49-5.239 3.026 3.025 5.239 5.239-3.025-3.025-5.24Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.29 52.7-4.33-1.696-1.696 4.33 4.33 1.696 1.696-4.33ZM14.6 11.61a3.48 3.48 0 1 0 0-6.96 3.48 3.48 0 0 0 0 6.96ZM1.3 26.53l17.57 12.4M11.72 118l46.35-18.28M35.76 98.71l16.37-3.07",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57 82.3s23.07 27.05 58.47 4.15",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.25 88.93.53-2.34-2.34-.53 1.22-.77 2.34.53-.53 2.34-1.22.77Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 96.33c7.146 0 12.94-5.794 12.94-12.94 0-7.147-5.794-12.94-12.94-12.94-7.147 0-12.94 5.793-12.94 12.94 0 7.146 5.793 12.94 12.94 12.94Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.04 94.65c7.146 0 12.94-5.794 12.94-12.94 0-7.147-5.794-12.94-12.94-12.94-7.147 0-12.94 5.793-12.94 12.94 0 7.146 5.793 12.94 12.94 12.94Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 84.8a8.318 8.318 0 0 0 11.59-2.07",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.45 73.53 2.75 2.16 3.33-1.03-1.21 3.27 2.02 2.85-3.49-.13-2.09 2.79-.95-3.36-3.31-1.12 2.91-1.94.04-3.49ZM17.2 72.49l3.43-.66 1.4-3.2 1.69 3.06 3.47.35-2.39 2.54.75 3.41-3.16-1.48-3.01 1.76.43-3.46-2.61-2.32Z",
    fill: "#F76707"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanceLeftImage);
export default __webpack_public_path__ + "static/media/danceLeftImage.10774ca737f37101c758a5e2372c4712.svg";
export { ForwardRef as ReactComponent };